'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useCommonData } from '@udemy-v2/common-data';
import { Header as ReactHeader } from '@udemy-v2/react-header';
import { useIsOrgHost } from '@/lib/hooks/use-is-org-host';
import { useIsOrgBrandingPending, useOrgBranding } from '@/lib/hooks/use-org-branding';
import { useUserHasOrganization } from '@/lib/hooks/use-user-has-organization';
import styles from './default-header.module.scss';
export const Header = () => {
  const $ = _c(7);
  const commonData = useCommonData();
  const isOrgHost = useIsOrgHost();
  const hasOrganization = useUserHasOrganization();
  const isBrandingPending = useIsOrgBrandingPending();
  const t0 = useOrgBranding() ?? {};
  let isAnonymous;
  let organization;
  if ($[0] !== t0) {
    ({
      isAnonymous,
      ...organization
    } = t0);
    $[0] = t0;
    $[1] = isAnonymous;
    $[2] = organization;
  } else {
    isAnonymous = $[1];
    organization = $[2];
  }
  const isLoggedIn = !!commonData?.user;
  const isVisitorTypeUnknown = !!commonData?.page?.isLoading || isBrandingPending;
  const shouldShowPlaceholder = isOrgHost && !isLoggedIn && isVisitorTypeUnknown;
  const shouldShowLoggedOutOrgHeader = hasOrganization && !isLoggedIn && isAnonymous;
  if (shouldShowPlaceholder) {
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className={styles.placeholder} data-testid="header-placeholder" aria-hidden={true} />;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    return t1;
  }
  if (shouldShowLoggedOutOrgHeader) {
    let t1;
    if ($[4] !== organization) {
      t1 = <ReactHeader variant="org-logged-out" organization={organization} />;
      $[4] = organization;
      $[5] = t1;
    } else {
      t1 = $[5];
    }
    return t1;
  }
  let t1;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ReactHeader />;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
};
export default Header;